import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import HeroSection from "@/pages/home/components/HeroSection";
import MessageSection from "@/pages/home/components/MessageSection";
import ImportantSection from "@/pages/home/components/ImportantSection";
import GallerySection from "@/pages/home/components/GallerySection";
import SearchSection from "@/pages/home/components/SearchSection";
import ContactSection from "@/pages/home/components/ContactSection";
import HomeSeo from "@/pages/home/components/HomeSeo";

const HomePage = () => {
  return (
    <div className="bg-[#f5f0e8] min-h-screen">
      <HomeSeo />
      <Header />
      <main>
        <HeroSection />
        <MessageSection />
        <ImportantSection />
        <GallerySection />
        <SearchSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
